import { getListCountry } from "../../data/repository/countryRepo";

export const getListCountryUseCase = async () => {
  const response = await getListCountry();
  return response;
};
